import React, { Component } from "react";
import DropzoneComponent from "react-dropzone-component";
import "react-dropzone-component/styles/filepicker.css";
import "dropzone/dist/min/dropzone.min.css";
var ReactDOMServer = require('react-dom/server');

var dropzoneComponentConfig = {
	postUrl: "no-url",
};
var dropzoneConfig = {
	acceptedFiles: "image/jpeg,image/png",
	autoProcessQueue: false, //This prevents automatic posting until we press 'save'
	maxFilesize: 2, //in megabytes.
	maxFiles: 1,
	previewTemplate: ReactDOMServer.renderToStaticMarkup(
		<div className="preview-container">
			<img width="auto" height="100" data-dz-thumbnail className="roundImage" alt="" />
			<a href="#/" className="remove" data-dz-remove>
				<i className="glyph-icon simple-icon-trash removebin" />
			</a>
		</div>
  )
};

class CustomImage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: null,
			thumbValue: null,
			loading: true,
			fileLoaded: false,
			fileAttached: false
		};
	}

	componentDidMount() {
		
		if (this.props.value !== '...') {
			this.setState({
				thumbValue: (this.props.value.indexOf('http') === -1 && this.props.opts && this.props.opts.base ? this.props.opts.base : '') + this.props.value,
				fileLoaded: true,
				loading: false
			});
			
			this.handleChange('sameimage');
		}
	}

	handleChange = value => {
		this.setState({ [this.props.name]: value });
		this.props.onChange(value);
	};
			
	addedfile (file, context) {
		
		// if (this.state.value !== "") {
		// 	//Display error & remove the file. cannot upload duplicates.
		// 	this.state.myDropZone.removeFile(file);
		// }
		
		var img = document.createElement("img");
		var reader = new FileReader();
		reader.onload = function (e) {
			img.src = e.target.result;
			img.onload = function () {

				var canvas = document.createElement("canvas");
				var ctx = canvas.getContext("2d");
				ctx.drawImage(img, 0, 0);

				var MAX_WIDTH = context.props.opts.maxWidth;
				var MAX_HEIGHT = context.props.opts.maxHeight;
				var width = img.width;
				var height = img.height;

				if (width > height) {
					if (width > MAX_WIDTH) {
						height *= MAX_WIDTH / width;
						width = MAX_WIDTH;
					}
				} else {
					if (height > MAX_HEIGHT) {
						width *= MAX_HEIGHT / height;
						height = MAX_HEIGHT;
					}
				}
				canvas.width = width;
				canvas.height = height;
				console.log(MAX_WIDTH);
				
				ctx.drawImage(img, 0, 0, width, height);

				var dataurl = canvas.toDataURL("image/png");

				//We have the base64 string now.
				//Set the value in the form.
				context.setState({ [context.props.name]: dataurl, fileLoaded: true, fileAttached: true, thumbValue: dataurl });
				context.props.onChange(dataurl);
			}
		}
		reader.readAsDataURL(file);
	}

	clear() {
		this.setState({ fileLoaded: false });
		this.handleChange('removeimage'); // set to remove
	};

	render() {
		if (this.state.loading) {
			return ('Loading...')
		}
		else if (!this.state.fileLoaded) {
			return (
				<div>
					<DropzoneComponent
						eventHandlers={{ addedfile: (file) => this.addedfile(file, this) }}
						config={dropzoneComponentConfig}
						djsConfig={dropzoneConfig}
					/>
				</div>
			);
		} else {
			return (
				<div>
					<img
						src={this.state.thumbValue}
						width="auto"
						height="100"
						alt="Preview"
						className="roundImage"
					/>
					<span href="#" title="Clear file" className="removebin" onClick={e => this.clear()}>
						<i className="glyph-icon simple-icon-trash pointer"></i>
						{false && this.state.fileAttached && <span>Not saved</span>}
					</span>
					
				</div>				
			);
		}
	}
};

export default CustomImage;